import { Component, OnInit, AfterViewInit } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

import { DomainService } from '../../../services/domain.service';
import { FullscreenService } from '../../../services/fullscreen.service';
import { NotificationService } from '../../../services/notification.service';
import { ConfigService } from '../../../services/config.service';
import {EvaluationService} from '../evaluation.service';

declare var $: any;

@Component({
    selector: 'itpx-evaluation-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})

export class EvaluationNavbarComponent implements OnInit, AfterViewInit {

    private defaultAvatar: string;
    private imgUrl;
    private domain;
    private backUrl;

    private isViewingContent: boolean;

    constructor(
        private domainService: DomainService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router,
        private fullscreenService: FullscreenService,
        private evaluationService: EvaluationService
    ) { }

    ngOnInit() {
        this.imgUrl = this.configService.get('server').images;
        this.domain = this.domainService.getDomain();
        this.defaultAvatar = this.configService.get('links').defaultAvatar;

        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .map((e: NavigationEnd) => e.url.indexOf('/evaluation/scorm') > -1)
            .subscribe(val => this.isViewingContent = val);

        if(this.router.url.indexOf('evaluation/course/') != -1) {
          this.backUrl = this.router.url;
          this.evaluationService.storeUrl(this.backUrl);
        }else
          this.backUrl = this.evaluationService.retrieveUrl();
    }

    ngAfterViewInit() {
        $(document).on('click.nav', '.navbar-collapse.in', function (e) {
            if ($(e.target).is('a')) {
                $(this).removeClass('in').addClass('collapse');
            }
        });
    }

    private onFullscreenClicked() {
        let mainContainer = document.getElementById('main-c');
        this.fullscreenService.enterFullscreen(mainContainer);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/navbar/navbar.component.ts